import contactSection from "../../components/contactSection/index.vue";
import newsLetters from "../../components/newsLetters/index.vue";
import partenairesSection from "../../components/partenairesSection/index.vue";
import heroSection from "../../components/heroSection/index.vue";

export default {
  name: "contactPage",
  components: {
    heroSection,
    contactSection,
    newsLetters,
    partenairesSection
  },
  methods: {
    track() {
      this.$gtag.screenview({
        screen_name: 'Contact page',
      })
      this.$gtag.pageview({
        page_path: '/contact',
      })
    }
  }
};
